const types = {
  SET_CUSTOMER: 'SET_CUSTOMER',
};

export default types;
